import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/sqxbonds-UI/apps/src/components/common/Footer.tsx");
